// extracted by mini-css-extract-plugin
export default {"wrapper":"mq-z","reviewFormSuccess":"nq-z","header":"oq-z","message":"pq-z","paragraph":"qq-z","lottieContainer":"rq-z"};